export type FooterLlmKey = 'chatgpt' | 'claude' | 'grok'

export enum ResourceType {
  AlignedDelegates = 'AlignedDelegates',
  CoreUnit = 'CoreUnit',
  Delegates = 'Delegates',
  Keepers = 'Keepers',
  EcosystemActor = 'EcosystemActor',
  Scopes = 'Scopes',
  SpecialPurposeFund = 'SpecialPurposeFund',
  System = 'System',
}

export enum BudgetStatus {
  Draft = 'Draft',
  Review = 'Review',
  Escalated = 'Escalated',
  Final = 'Final',
  AutoGenerated = 'AutoGenerated',
}

export enum TeamCategory {
  Technical = 'Technical',
  Support = 'Support',
  Operational = 'Operational',
  Business = 'Business',
  RWAs = 'RWAs',
  Growth = 'Growth',
  Finance = 'Finance',
  Legal = 'Legal',
  ScopeFacilitator = 'ScopeFacilitator',
  All = 'All',
}

export enum TeamRole {
  ActiveEcosystemActor = 'ActiveEcosystemActor',
  ScopeFacilitator = 'ScopeFacilitator',
  AdvisoryCouncilMember = 'AdvisoryCouncilMember',
  Facilitator = 'Facilitator',
  ResearchExpert = 'ResearchExpert',
  ProjectLead = 'ProjectLead',
  DataExpert = 'DataExpert',
  TechExpert = 'TechExpert',
  TeamLead = 'TeamLead',
  All = 'All',
}

export enum ProgressStatus {
  DRAFT = 'DRAFT',
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
}

export enum SortEnum {
  Neutral = 'neutral',
  Asc = 'asc',
  Desc = 'desc',
  Disabled = 'disabled',
}
